import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const api = {
  getHeroSlides: () => client.get('/hero-slides').then((r) => r.data),
  getStats: () => client.get('/stats').then((r) => r.data),
  getProjects: () => client.get('/projects').then((r) => r.data),
  getNews: (category) =>
    client
      .get('/news', { params: category ? { category } : {} })
      .then((r) => r.data),
  getCommunity: () => client.get('/community').then((r) => r.data),
  getTechVideos: () => client.get('/tech-videos').then((r) => r.data),
  submitContact: (payload) => client.post('/contact', payload).then((r) => r.data),
  subscribeNewsletter: (email) =>
    client.post('/newsletter', { email }).then((r) => r.data),
};

export default api;
